import type { StaffProviderHealthEntry } from "@lafayette/schemas";

import { Icon } from "../../ui/icon";
import { StatusBadge, type StatusTone } from "../../ui/status-badge";
import { statusGlyphs, statusHints, statusLabels } from "../labels";

// Small parts of the diagnostics pages. A status is an icon AND a word (`StatusBadge`), never colour alone.

type Status = StaffProviderHealthEntry["status"];

const statusTones: Readonly<Record<Status, StatusTone>> = {
  NOT_CONFIGURED: "neutral",
  FAKE: "info",
  UNKNOWN: "neutral",
  OK: "success",
  DEGRADED: "warning",
  DOWN: "danger",
};

/** The status of one provider. The hint (what the status means) is the `title` of the wrapper, as before. */
export function ProviderStatusBadge({ status }: Readonly<{ status: Status }>) {
  return (
    <span title={statusHints[status]} className="inline-flex">
      <StatusBadge tone={statusTones[status]} glyph={<Icon name={statusGlyphs[status]} />}>
        {statusLabels[status]}
      </StatusBadge>
    </span>
  );
}

const evidenceTones = { FAKE: "warning", REAL: "success", NONE: "neutral" } as const;

/** The evidence label of a payment result: FAKE is never launch evidence, REAL is the real provider, NONE means no provider. */
export function EvidenceBadge({ evidence }: Readonly<{ evidence: "FAKE" | "REAL" | "NONE" }>) {
  return <StatusBadge tone={evidenceTones[evidence]}>Evidence: {evidence}</StatusBadge>;
}
